import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { interval, Observable, of, ReplaySubject } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { StoryStatusResponse } from 'src/app/models/Story/StoryStatusResponse';
import {isBigEventOptimization} from "@src/configs/view_only";

@Injectable({
  providedIn: 'root'
})
export class HeartbeatService {

  protected heartBeatUrl: string;
  protected timeout = 3000;
  private isStory = true;
  private response: ReplaySubject<StoryStatusResponse[]> = new ReplaySubject<StoryStatusResponse[]>(1);

  get response$(): Observable<any> {
    return this.response.asObservable();
  }

  get queryParams(): HttpParams {
    let params: HttpParams = new HttpParams().set('r',  Math.random().toString());
    if (this.isStory) {
      params = params.append('requestedData', 'stories');
    }
    return params;
  }

  constructor(private http: HttpClient) {
    if (isBigEventOptimization) {
      this.timeout = 30000;
    }
  }

  isStoryReqActive(): boolean {
    return this.isStory;
  }

  setStoriesQuery(val: boolean): void {
    console.log('setStoriesQuery', val)
    this.isStory = val;
  }

  init(): void {
    this.defaultHeartBeatInit();
  }

  defaultHeartBeatInit(): void {
    const wnd: any = window as any;

    if (wnd.DEF_HEARTBEAT_TIMEOUT) {
      this.timeout = wnd.DEF_HEARTBEAT_TIMEOUT;
    }

    if (wnd.HEARTBEAT_URL) {
      this.heartBeatUrl = wnd.HEARTBEAT_URL;
      (window as any).hearbeatReplace = this.heartBeat;
      this.heartBeat();
    } else {
      console.error('HEARTBEAT_URL is not defined');
    }

  }

  heartBeat(): void {
    if (
      ['/link-share/view', '/fast-line'].some(toIgnore => {
        console.log('heartbeat disabled');
        return location.href.includes(toIgnore);
      })
    ) {
      return;
    }

    interval(this.timeout)
      .pipe(
        map(() => {
          const params = this.queryParams;
          return this.http.get(this.heartBeatUrl, {params})
            .pipe(
              catchError((err) => {
                console.log('Heartbeat error', err);
                this.handleError(err);
                return of(undefined);
              })
            ).subscribe((res) => {
              console.log('Heartbeat response', res, typeof res);
              if (this.isStory && res) {
                this.response.next(res);
              }
            });
        }),
      ).subscribe();
  }

  handleError(error) {
    if (error.status && error.status === 403) {
      return window.location.href = '/site/login';
    }
  }
}
